import { useEffect, useMemo, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";
import { getDataScale } from "../../../styles/dataColors.js";

// data: array de puntos [lat, lng, intensidad]
const HeatmapLayer = ({ data = [], radius = 25, opacity = 0.7, highDensityThreshold = 10 }) => {
    const map = useMap();
    const heatLayerRef = useRef(null);
    const maxIntensity = Math.max(1, Number(highDensityThreshold) || 10);
    const normalizedData = useMemo(
        () =>
            data.map((point) => {
                const lat = Number(point?.[0]);
                const lng = Number(point?.[1]);
                const rawIntensity = Number(point?.[2] ?? 1);
                const intensity = Number.isFinite(rawIntensity) ? Math.max(0, rawIntensity) : 1;
                return [lat, lng, intensity];
            }).filter((point) => Number.isFinite(point[0]) && Number.isFinite(point[1])),
        [data]
    );

    useEffect(() => {
        // Eliminar capa anterior
        if (heatLayerRef.current) {
            map.removeLayer(heatLayerRef.current);
        }

        if (normalizedData.length > 0) {
            const [low, , mid, high, top] = getDataScale();

            heatLayerRef.current = L.heatLayer(normalizedData, {
                radius,
                blur: Math.max(10, Math.round(radius * 0.65)),
                minOpacity: Math.max(0.1, Math.min(1, opacity)),
                max: maxIntensity,

                gradient: {
                    // Cortes duros por densidad (escala secuencial, no categórica —
                    // ver spec-03 escenario 4):
                    // 1-2 (<=0.2) baja, 3-4 (0.3-0.4) media,
                    // 5-9 (0.5-0.9) alta, 10+ (1.0) máxima.
                    0.0: low,
                    0.2: low,
                    0.3: low,
                    0.4: mid,
                    0.4001: mid,
                    0.9: high,
                    0.9001: high,
                    1.0: top
                }
            }).addTo(map);
        }
        // Cleanup
        return () => {
            if (heatLayerRef.current) {
                map.removeLayer(heatLayerRef.current);
            }
        };
    }, [normalizedData, map, radius, opacity, maxIntensity]);

    return null;
};

export default HeatmapLayer;
